export const formatRelativeTime = (timestamp) => {
  if (!timestamp) return "";

  const now = Date.now();
  const date = new Date(timestamp).getTime();

  if (isNaN(date)) return "";

  const diffInSeconds = Math.floor((now - date) / 1000);

  const intervals = [
    { label: "y", seconds: 31536000 },
    { label: "mo", seconds: 2592000 },
    { label: "d", seconds: 86400 },
    { label: "h", seconds: 3600 },
    { label: "m", seconds: 60 },
  ];

  for (const interval of intervals) {
    const value = Math.floor(diffInSeconds / interval.seconds);
    if (value > 0) {
      return `${value}${interval.label}`;
    }
  }

  return "just now";
};

export const formatDateToLocaleDateString = (isoString) => {
  if (!isoString) return "N/A";
  return new Date(isoString).toLocaleDateString("en-AU", {
    // day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const formatAge = (isoString) => {
  if (!isoString) return "N/A";
  const birthDate = new Date(isoString);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return `${formatDateToLocaleDateString(isoString)} (${age} yrs)`;
};
